import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import useRewards from '../../../../../hooks/useRewards';
import { isCertificateExpiringSoon } from '../../../../../helpers/certificatesUtils';
import { ExpiringTag } from './subcomponents';
var ExpiringSoonBadge = function (_a) {
    var certificateExpiryDate = _a.certificateExpiryDate;
    var t = useTranslation().t;
    var clientId = useRewards().clientId;
    var isExpiringSoon = isCertificateExpiringSoon(clientId, certificateExpiryDate);
    return isExpiringSoon ? (_jsx(ExpiringTag, { children: t('fullDetailsPage.certificate.expiringSoon') })) : null;
};
export default ExpiringSoonBadge;
